export const BILLER_TABLE_HEADERS = [
  { label: 'BILLER', colspan: 3 },
  { label: 'FIRST FIELD', colspan: 3 },
  { label: 'SECOND FIELD', colspan: 3 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
];

export const BILLER_TABLE_SUB_HEADERS = [
  { label: 'NAME', key: 'name' },
  { label: 'CATEGORY', key: 'category' },
  { label: 'DESCRIPTION', key: 'description' },
  { label: 'LABEL', key: 'firstFieldName' },
  { label: 'FORMAT', key: 'firstFieldFormat' },
  { label: 'MAX LENGTH', key: 'firstFieldWidth' },
  { label: 'LABEL', key: 'secondFieldName' },
  { label: 'FORMAT', key: 'secondFieldFormat' },
  { label: 'MAX LENGTH', key: 'secondFieldWidth' },
  { label: 'CONV FEE', key: 'convFee', noTopBorder: true },
  { label: 'SERVICE FEE', key: 'serviceFeePercentage', noTopBorder: true },
  { label: 'SERVICE FEE FIXED', key: 'serviceFeeFixed', noTopBorder: true },
  { label: 'STATUS', key: 'status', noTopBorder: true },
  { label: 'LIMIT', key: 'limit', noTopBorder: true },
  { label: 'IMAGE URL', key: 'imageUrl', noTopBorder: true },
  { label: 'ACTION', key: 'status', noTopBorder: true },
];
